import { render, staticRenderFns } from "./tableTemolate.vue?vue&type=template&id=0e20f4dc&scoped=true&"
import script from "./tableTemolate.vue?vue&type=script&lang=js&"
export * from "./tableTemolate.vue?vue&type=script&lang=js&"
import style0 from "./tableTemolate.vue?vue&type=style&index=0&id=0e20f4dc&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20f4dc",
  null
  
)

export default component.exports